<template>
  <div class="edit-row">
    <div data-testid="planned-leave-edit-from">
      <label for="From">From</label>
      <AlDatePicker
        :modelValue="month"
        v-model="startDate"
        name="From"
        :min="minDate"
        :max="endDate || maxDate"
      />
    </div>

    <div data-testid="planned-leave-edit-to">
      <label for="To">To</label>
      <AlDatePicker
        :modelValue="maxDate"
        v-model="endDate"
        name="To"
        :min="startDate || minDate"
        :max="maxDate"
      />
    </div>
    <div data-testid="planned-leave-edit-percentage">
      <label>Percentage</label>
      <Decimal
        v-model="percentage"
        append="%"
        :min="0"
        :max="100"
        :step="0.1"
        :decimals="1"
      />
    </div>
    <div data-testid="planned-leave-edit-calendars">
      <label>Calendars</label>
      <AlSelect
        v-model="calendars"
        :options="calendarOptions"
        track-by="id"
        placeholder="All calendars"
        :multiple="true"
        :close-on-select="false"
      ></AlSelect>
    </div>
    <div data-testid="planned-leave-edit-tasks">
      <label>Leave types</label>
      <AlSelect
        v-model="types"
        :options="typeOptions"
        track-by="id"
        placeholder="All leaves"
        :multiple="true"
        :close-on-select="false"
      ></AlSelect>
    </div>
    <div class="edit-actions">
      <AlButton
        @click="save"
        data-testid="save-row"
        id="planned-leave-edit-save-row"
        ><i class="far fa-check" @click="save"
      /></AlButton>
      <AlButton
        @click="cancel"
        variant="secondary"
        data-testid="delete-row"
        id="planned-leave-edit-cancel-row"
        ><i class="far fa-times"
      /></AlButton>
    </div>
  </div>
</template>

<script>
import {
  AlDatePicker,
  Al2Button as AlButton,
  AlSelect,
} from "@playvox/almendra-components";
import { Decimal } from "@agyletime/wfm-vue-common";
import {
  format,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export default {
  name: "EditPlannedLeaveRow",
  components: {
    AlDatePicker,
    AlButton,
    Decimal,
    AlSelect,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    leave: {
      type: Object,
      required: true,
    },
    month: {
      type: String,
      required: true,
    },
    calendarOptions: {
      type: Array,
      required: true,
    },
    typeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    let startDate = utcToZonedTime(this.month);
    let endDate = endOfMonth(utcToZonedTime(this.month));

    if (this.leave?.startDate) {
      startDate = utcToZonedTime(this.leave.startDate, "UTC");
    }

    if (this.leave?.endDate) {
      endDate = utcToZonedTime(this.leave.endDate, "UTC");
    }

    return {
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
      percentage: this.leave?.percentage || 0,
      calendars: this.leave?.calendars || [],
      types: this.leave?.types || [],
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      const result = {
        startDate: zonedTimeToUtc(
          startOfDay(utcToZonedTime(new Date(this.startDate), "UTC")),
          "UTC"
        ),
        endDate: zonedTimeToUtc(
          endOfDay(utcToZonedTime(new Date(this.endDate), "UTC")),
          "UTC"
        ),
        percentage: this.percentage,
        calendars: this.calendars,
        types: this.types,
      };
      this.$emit("save", result);
    },
  },
  computed: {
    minDate() {
      const date = utcToZonedTime(this.month);
      return format(startOfMonth(date), "yyyy-MM-dd");
    },
    maxDate() {
      const date = utcToZonedTime(this.month);
      return format(endOfMonth(date), "yyyy-MM-dd");
    },
    defaultDate() {
      const date = utcToZonedTime(this.month);
      return format(date, "yyyy-MM-dd");
    },
  },
};
</script>
